import React from 'react'
import HoasForm from './HoasForm'

const NewHoaPage = () => {
  return (
    <>
     <HoasForm formType='create' currentHoaId={null} ></HoasForm>
    </>
  )
}

export default NewHoaPage
